// extracted by mini-css-extract-plugin
export var editButton = "_ny-0";